import {
    Component,
    OnInit,
    ViewChild,
    Inject,
    OnDestroy,
    Input,
    ViewEncapsulation,
    ElementRef,
    Output,
    EventEmitter
} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { EFormTab } from '../e-form-tab.model';
import { EFormPage } from '../e-form-page.model';
import { EFormService } from '../e-form.service';
import { TabsComponent } from '../../controls/tabs/tabs.component';
import { Lookup } from '../../lookup/lookup.model';
import * as _ from 'lodash';
import { EFormControl } from '../e-form-control.model';
import { EFormDataObject } from '../e-formDataObject.model';
import { ErrorList } from '../../controls/error-prompt/error-list.model';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { Subscription } from 'rxjs';
import { SharedService } from '../../shared.service';
import { EFormAttachment } from '../e-form-attachment.model';
import { UserService } from '../../user/user.service';
import { YearService } from '../../year/year.service';
import { EForm } from '../e-form.model';
import { Year } from '../../year/year.model';
import { StudentService } from '../../student/student.service';
import { Student } from '../../student/student.model';
import { EFormInstance } from '../e-form-instance.model';
import { EFormColumn } from '../e-form-column.model';
import { SpinnerService } from '../../spinner/spinner.service';
import { EFormChangeHistory } from '../e-form-change-history.model';
import { EFormRow } from '../e-form-row.model';
import { TranslationService } from '../../translation/translation.service';
import { LoginService } from '../../../shared-modules/login/login.service';
import { PDFExportComponent } from '@progress/kendo-angular-pdf-export';
import { System } from '../../System';
import { Group, exportPDF } from '@progress/kendo-drawing';
import { EFormConfiguration, enmEFormViewModes, PageObjectTypes } from '../e-form-config.model';
import { CustomizationService } from '../../../admin360/customization/customization.service';
import { TylTranslation } from '../../models/tyl-translation.model';
import { take } from 'rxjs/operators';
import { StudentHeaderComponent } from '../../student-header/student-header.component';
import { CustomizationFrameworkService } from '../../../shared-modules/customization-framework/customization-framework.service';

@AutoUnsubscribe({ includeArrays: true })
@Component({
    selector: 'app-e-form-viewer',
    templateUrl: './e-form-viewer.component.html',
    styleUrls: ['./e-form-viewer.component.css'],
    encapsulation: ViewEncapsulation.None
})
export class EFormViewerComponent implements OnInit, OnDestroy {

    eFormData: EFormDataObject;
    eFormDataToPDF: EFormDataObject;
    selectedTab: EFormTab;
    selectedPage: EFormPage;
    selectedForm: EForm;
    selectedInstance: EFormInstance;
    tabNames: string[] = [];
    languages: Lookup[] = [];
    isPreview = false;
    isReview = false;
    editable = true;
    useInstance = true;
    showConditionalObjects = false;
    selectedLanguage = 'en';
    formControls: EFormControl[] = [];
    showNextPreviousButtons = false;
    selectedYear: Year;
    selectedStudent: Student;
    errors: ErrorList[] = [];
    subscriptions: Subscription[] = [];
    printProgress = 0;
    showPrintDiv = false;
    tabViewStatus: any[] = [];
    visibleTabs: EFormTab[] = [];
    allowedFileExtensions = ['.pdf', '.bmp', '.jpg', '.png'];
    allowedImageExtensions = ['.bmp', '.jpg', '.png'];
    maxFileSizeKB = 0;  // set in eFormService
    changes: EFormChangeHistory[] = [];
    disableMergeFields = false;
    selectedLanguageCode = '';
    languageChange = false;
    showContent = true;
    showAllConditionalsPrint = false;
    @ViewChild(TabsComponent) tabs: TabsComponent;
    @ViewChild(StudentHeaderComponent) studentHeader: StudentHeaderComponent;
    @ViewChild('printRef', { read: ElementRef, static: true }) printRef: ElementRef;
    @ViewChild('pdf', { static: true }) pdfExportRef: PDFExportComponent;
    @ViewChild('validationTrigger', { read: ElementRef, static: true }) validateButton: ElementRef;
    private subscription: Subscription;
    @Output() renderCompleted = new EventEmitter<boolean>();
    @Output() initialized = new EventEmitter<boolean>();
    @Output() valueChanged = new EventEmitter<string>();
    @Input() showPrintDivInput = false;
    @Input() configInput: EFormConfiguration;
    @Input() changesInput: EFormChangeHistory[];
    @Input() languageIdOverride: number;
    @Input() pageID: number;
    @Input() masterId: number;
    @Input() designPageIndex: number;
    @Input() formName: string;
    @Input() showSubmittedInfo: boolean;
    @Input() isBehaviorLetter = false;
    labels: string[] = [];
    serviceLabels: string[] = [];
    serviceControls: EFormControl[] = [];
    localPrint = false;
    columnInitializedBuffer = false;
    pdfName: string;
    selectedPageNumber: number;
    dataURIs = [];
    addFormToPDFStarted = false;
    config: EFormConfiguration;
    fileNameOverride = false;
    fileNameInput = '';
    hideKendoBottomPadding = false;

    isLP = true;
    isFP = true;

    translations: TylTranslation[] = [];
    V10 = false;
    refreshEnrollmentGrade: boolean;
    constructor(
        private dialogRef: MatDialogRef<EFormViewerComponent>,
        private eFormService: EFormService,
        private sharedService: SharedService,
        private userService: UserService,
        private yearService: YearService,
        private loginService: LoginService,
        private dialog: MatDialog,
        private studentService: StudentService,
        private spinnerService: SpinnerService,
        private translationService: TranslationService,
        private customizationService: CustomizationService,
        private customizationFrameworkService: CustomizationFrameworkService,
        @Inject(MAT_DIALOG_DATA) public data: any,
    ) {
        if (data) {
            if (data.config) {
                this.config = data.config;
            }
            if (data.changes) {
                this.changes = data.changes;
            } else {
                this.changes = this.changesInput;
            }
            this.eFormService.changes = this.changes;
        }

        this.maxFileSizeKB = this.eFormService.maxFileSizeKB;
        this.V10 = this.loginService.LoginSettings.V10;
    }

    ngOnInit() {
        if (!this.config && this.configInput) {
            this.config = this.configInput;
        } else if (!this.config) {
            this.config = new EFormConfiguration();
        }

        if (this.config.ViewMode == enmEFormViewModes.Template) {
            this.isPreview = true;
            this.editable = true;
            this.disableMergeFields = true;
        } else if (this.config.ViewMode == enmEFormViewModes.Instance) {
            this.isPreview = true;
            // this.editable = false;
            this.editable = true;
            this.disableMergeFields = true;
        } else if (this.config.ViewMode == enmEFormViewModes.Review) {
            this.editable = false;
            this.isReview = true;
        } else if (this.config.ViewMode == enmEFormViewModes.Page) {
            this.editable = true;
            this.isReview = false;
            this.isPreview = this.config.IsPreview;
            this.hideKendoBottomPadding = true;
        } else if (this.config.ViewMode == enmEFormViewModes.CustomPage) {
            this.editable = true;
            this.isReview = false;
            this.isPreview = this.config.IsPreview;
            this.hideKendoBottomPadding = true;
            if (this.config) {
                this.config.HideTitle = true;
            }
        } else if (this.config.ViewMode == enmEFormViewModes.FRMA) {
            this.editable = true;
            this.isReview = false;
            this.isPreview = this.config.IsPreview;
            this.hideKendoBottomPadding = true;
            this.config.HideTitle = true;
        }

        this.eFormService.viewType = this.config.ViewMode;

        if (this.config.ReadOnly) {
            this.editable = false;
        }
        if (this.config) {
            this.useInstance = this.config.UseInstance;
        }

        if (!this.pageID) {
            this.selectedForm = _.cloneDeep(this.eFormService.selectedForm);
            if(!this.V10 && this.selectedForm && this.selectedForm.Year_ID > 0) {
                const formYear = _.cloneDeep(this.yearService.allYears.find(year => year.Id == this.selectedForm.Year_ID));
                if(formYear) {
                    this.selectedYear = formYear;
                }
            }

            this.initializePage();
            this.initialized.emit(true);
        } else {
            this.customizationService.getDesignPageByIDs(false, [this.pageID]).pipe(take(1)).subscribe(page => {
                if (page.length == 1) {
                    const eForm: EForm = new EForm;

                    eForm.FormData = page[0].FormData;

                    this.selectedForm = _.cloneDeep(eForm);

                    this.initializePage();
                    this.initialized.emit(true);
                }
            });
        }
    }

    // eslint-disable-next-line complexity
    initializePage() {
        if (this.selectedForm && this.selectedForm.Student_ID > 0) {
            this.setSelectedStudent();
        }
        this.eFormData = _.cloneDeep(this.eFormService.selectedFormData);
        this.setInitialVisibility();
        // Should only be called for new forms to default DB fields to current values in DB - we will also only do this for single-student forms for now
        if (!this.isPreview && this.selectedForm && (!this.selectedForm.ID || this.selectedForm.ID <= 0) && this.selectedForm.TemplateType == 'student') {
            this.setLinkedDBFieldValues();
        }
        this.getTabs();
        this.getLanguages();
        this.selectedPageNumber = this.getSelectedPageNumber();
        this.subscriptions.push(this.eFormService.observableControlValueChangedStream$.subscribe(parentControl => {
            this.checkConditionalObjects(parentControl);
            if (parentControl.CustomField && parentControl.DesignPageIndex == this.designPageIndex) {
                this.valueChanged.emit(parentControl.CustomFieldRefName);
            }
        }));
        if (this.eFormData.Tabs.length > 1 || this.eFormData.Tabs[0].Pages.length > 1) {
            this.showNextPreviousButtons = true;
        }
        if (!this.isPreview) {
            let studentId = 0;
            let parentId = 0;
            let incidentId = 0;
            let involvementType = ' ';
            let batcRunDate = null;
            let trackingType = -1;
            if (this.selectedForm) {
                studentId = (this.selectedForm.Student_ID ? this.selectedForm.Student_ID : 0);
                parentId = (this.selectedForm.ParentMem_ID ? this.selectedForm.ParentMem_ID : 0);
                incidentId = (this.selectedForm.Incident_ID ? this.selectedForm.Incident_ID : 0);
                involvementType = (this.selectedForm.InvolvementType ? this.selectedForm.InvolvementType : ' ');
                trackingType = (this.selectedForm.TrackingType > -1 ? this.selectedForm.TrackingType : -1);
                batcRunDate = (this.selectedForm.BatchRunDate ? this.selectedForm.BatchRunDate : null);
            } else if (this.config.ViewMode == enmEFormViewModes.Page) {
                switch (this.config.PageObjectType) {
                    case PageObjectTypes.Student:
                        studentId = this.masterId;
                        break;
                    default:
                        this.disableMergeFields = true;
                        break;
                }
            }
            this.eFormService.getMergeFieldValues(this.eFormData, this.yearService.student360Year.SchoolID, this.yearService.student360Year.Id, studentId, parentId, incidentId, involvementType, this.config, this.selectedForm ? this.selectedForm.NonresidentParents : false, trackingType, batcRunDate);
            if (this.useInstance) {
                this.getInstance();
            }
        }
        if (this.showPrintDivInput) {
            this.config.ViewMode = enmEFormViewModes.Form;
            this.showPrintDiv = this.showPrintDivInput;
        }
        this.eFormData.Tabs.forEach(tab => {
            if (tab.Visible) {
                tab.Pages.forEach(page => {
                    if (page.Visible) {
                        page.Columns.forEach(col => {
                            const colObj = {
                                Column: col,
                                Initialized: false,
                                TabId: tab.Id,
                                PageId: page.Id
                            };
                            this.tabViewStatus.push(colObj);
                        });
                    }
                });
            }
        });

        this.getFormLabels();

        this.isFirstPage();
        this.isLastPage();
        this.eFormService.eFormAttachment = [];
    }

    getInstance() {
        this.subscriptions.push(this.eFormService.getEFormInstance(this.selectedForm.Instance_ID).subscribe(instance => {
            this.selectedInstance = instance;
        }));
    }

    setSelectedStudent() {
        if (this.userService.userType == 1) {
            this.subscriptions.push(this.studentService.getStudent(this.selectedForm.Student_ID).subscribe(student => {
                this.selectedStudent = student;
            }));
        } else {
            this.selectedStudent = this.studentService.students.find(o => o.Id == this.selectedForm.Student_ID);
        }
    }

    clearSelectedStudent() {
        this.studentService.clearSelectedStudent();
    }

    ngOnDestroy() {
        this.eFormService.clearMergeFieldValues();
        if (this.languageChange) {
            // changed for ONE-5073, the e-Form preview only uses tyl-translate now
            // this.userService.setUserLanguage('en').subscribe();
            this.translationService.overrideTranslationPipe = false;
        }
    }

    setInitialVisibility() {
        this.formControls = this.eFormService.getAllFormControls(this.eFormData);
        if (this.designPageIndex > -1) {
            this.eFormService.allFormControls = this.eFormService.allFormControls.concat(this.formControls);
            this.eFormService.allCustomFieldControls = this.eFormService.allCustomFieldControls.concat(this.formControls.filter(control => control.CustomField));
        } else {
            this.eFormService.allFormControls = this.formControls;
        }
        this.eFormData.Tabs.forEach(tab => {
            tab.Visible = true;
            if (tab.ParentObjectId > 0) {
                const parentObj = this.formControls.find(o => o.Id == tab.ParentObjectId);
                if (parentObj) {
                    tab.Visible = this.eFormService.isConditionMet(tab.Condition, parentObj);
                }
            }
            tab.Pages.forEach(page => {
                page.Visible = true;
                if (page.ParentObjectId > 0) {
                    const parentObj = this.formControls.find(o => o.Id == page.ParentObjectId);
                    if (parentObj) {
                        page.Visible = this.eFormService.isConditionMet(page.Condition, parentObj);
                    }
                }
            });
        });
    }

    checkConditionalObjects(parentControl: EFormControl) {
        this.eFormData.Tabs.forEach(tab => {
            if (tab.ParentObjectId == parentControl.Id) {
                tab.Visible = this.eFormService.isConditionMet(tab.Condition, parentControl);
                this.isFirstPage();
                this.isLastPage();
            }
            tab.Pages.forEach(page => {
                if (page.ParentObjectId == parentControl.Id) {
                    page.Visible = this.eFormService.isConditionMet(page.Condition, parentControl);
                    this.isFirstPage();
                    this.isLastPage();
                }
            });
        });
        this.getTabs();
    }

    getTabs() {
        this.tabNames = [];
        this.eFormData.Tabs.forEach(tab => {
            if (tab.Visible && tab.Pages.find(o => o.Visible) != null || this.showConditionalObjects || this.showAllConditionalsPrint || this.config.AlwaysShowAllConditionals) {
                this.tabNames.push(tab.Name);
                if (!this.visibleTabs.includes(tab)) {
                    this.visibleTabs.push(tab);
                }
            } else {
                const i = this.visibleTabs.findIndex(o => o == tab);
                if (i >= 0) {
                    this.visibleTabs.splice(i, 1);
                }
            }
        });
        if (this.tabNames.length > 0 && !this.selectedTab) {
            this.selectedTabChanged(this.tabNames[0]);
        }
    }

    updateAttachments(_callback) {
        const attachmentsToDelete: number[] = [];
        const newAttachments: EFormAttachment[] = [];
        this.eFormService.allFormControls.forEach(control => {
            if (control.ControlType == this.eFormService.controlTypes.attachment && control.PreviousAttachmentId && control.PreviousAttachmentId != control.AttachmentId) {
                attachmentsToDelete.push(control.PreviousAttachmentId);
            }
            if (control.ControlType == this.eFormService.controlTypes.attachment && !control.AttachmentId && control.Attachment && control.Attachment.FileDataBase64) {
                newAttachments.push(control.Attachment);
            }
        });
        if (attachmentsToDelete.length > 0) {
            this.deleteAttachments(attachmentsToDelete);
        }
        if (newAttachments.length > 0) {
            this.saveAttachments(newAttachments, _callback);
        } else {
            if (_callback) {
                _callback();
            }
        }
    }

    deleteAttachments(attachmentIds: number[]) {
        this.subscriptions.push(this.eFormService.deleteEFormAttachments(attachmentIds).subscribe(() => {
        }));
    }

    saveAttachments(attachments: EFormAttachment[], _callback) {
        this.subscriptions.push(this.eFormService.saveEFormAttachments(attachments).subscribe(result => {
            if (result && result.length == attachments.length) {
                for (let i = 0; i < result.length; i++) {
                    const newAttachment = result[i];
                    const oldAttachment = attachments[i];
                    const control = this.eFormService.allFormControls.find(o => o.Attachment == oldAttachment);
                    if (control) {
                        control.AttachmentId = newAttachment.ID;
                    }
                }
                if (_callback) {
                    _callback();
                }
            } else {
                this.sharedService.showBadSnackbar();
            }
        }));
    }

    clearAttachments() {
        this.eFormService.allFormControls.forEach(control => {
            control.Attachment = null;
            control.PreviousAttachmentId = null;
        });
    }

    selectedTabChanged(tabName: string, errors = null) {
        this.selectedTab = this.eFormData.Tabs.find(o => o.Name == tabName);
        if (this.selectedTab && this.selectedTab.Pages) {
            // this.selectedPage = this.selectedTab.Pages.find(o => o.Visible);
            if (errors && errors != null) {
                this.selectedTab.Pages.forEach(element => {
                    this.findColumn(element, element.Columns, errors);
                });
            } else {
                this.selectedPage = this.selectedTab.Pages.find(o => o.Visible);
            }
        }
        this.isFirstPage();
        this.isLastPage();
    }

    findColumn(element, Columns, errors) {
        Columns.forEach(Column => {
            if (Column.Controls.find(o => o.Label.trim() == errors.completFieldName.trim())) {
                this.selectedPage = element;
            } else {
                this.findRow(element, Column.Rows, errors);
            }
        });
    }

    findRow(element, Rows, errors) {
        Rows.forEach(rowElement => {
            if (rowElement.Controls.find(o => o.Label.trim() == errors.completFieldName.trim())) {
                this.selectedPage = element;
            } else {
                this.findColumn(element, rowElement.Columns, errors);
            }
        });
    }

    tabsClick() {
        this.selectedTab = this.selectedTab;
        setTimeout(() => {
            this.eFormService.mergeFieldPipeTrigger();
            if (this.showConditionalObjects) {
                this.showConditionalChange();
            }
        }, 0);
    }

    previousClick() {
        // this.validatePage();
        // if (this.errors.length == 0) {
        if (this.selectedTab && this.selectedPage) {
            let tabIndex = this.eFormData.Tabs.findIndex(o => o.Name == this.selectedTab.Name && o.Id == this.selectedTab.Id);
            let pageIndex = this.selectedTab.Pages.findIndex(o => o.Name == this.selectedPage.Name);
            let prevPage = this.selectedPage;
            let prevTab = this.selectedTab;
            do {
                if (pageIndex > 0) {
                    pageIndex = pageIndex - 1;
                    prevPage = prevTab.Pages[pageIndex];
                } else {
                    if (tabIndex > 0) {
                        tabIndex = tabIndex - 1;
                        prevTab = this.eFormData.Tabs[tabIndex];
                        prevPage = prevTab.Pages[prevTab.Pages.length - 1];
                        pageIndex = prevTab.Pages.length - 1;
                    }
                }
            }
            while (((!prevPage.Visible || !prevTab.Visible) && !this.showConditionalObjects && !this.config.AlwaysShowAllConditionals) && (pageIndex > 0 || tabIndex > 0));
            if (prevPage.Visible && prevTab.Visible || this.showConditionalObjects || this.config.AlwaysShowAllConditionals) {
                this.selectedPage = prevPage;
                if (prevTab != this.selectedTab) {
                    this.tabs.clickTabWithoutEvents(prevTab.Name);
                    this.selectedTab = prevTab;
                }
            }
            setTimeout(() => {
                this.eFormService.mergeFieldPipeTrigger();
                if (this.showConditionalObjects) {
                    this.showConditionalChange();
                }
            }, 0);
        }
        // }
        this.isFirstPage();
        this.isLastPage();
    }

    nextClick() {
        // this.validatePage();
        // if (this.errors.length == 0) {
        if (this.selectedTab && this.selectedPage) {
            let nextTab = this.selectedTab;
            let nextPage = this.selectedPage;
            let pageIndex = this.selectedTab.Pages.findIndex(o => o.Name == this.selectedPage.Name && o.Id == this.selectedPage.Id);
            let tabIndex = this.eFormData.Tabs.findIndex(o => o.Name == this.selectedTab.Name);
            const lastTabIndex = this.eFormData.Tabs.length - 1;
            let lastPageIndex = this.selectedTab.Pages.length - 1;
            do {
                lastPageIndex = nextTab.Pages.length - 1;
                if (pageIndex >= 0 && pageIndex < lastPageIndex) {
                    pageIndex = pageIndex + 1;
                    nextPage = nextTab.Pages[pageIndex];
                } else {
                    tabIndex = this.eFormData.Tabs.findIndex(o => o.Name == nextTab.Name);
                    if (tabIndex >= 0 && tabIndex < lastTabIndex) {
                        tabIndex = tabIndex + 1;
                        nextTab = this.eFormData.Tabs[tabIndex];
                        nextPage = nextTab.Pages[0];
                    }
                }
            }
            while (((!nextPage.Visible || !nextTab.Visible) && !this.showConditionalObjects && !this.config.AlwaysShowAllConditionals) && (tabIndex < lastTabIndex || pageIndex < lastPageIndex));
            if (nextPage.Visible && nextTab.Visible || this.showConditionalObjects || this.config.AlwaysShowAllConditionals) {
                this.selectedPage = nextPage;
                if (nextTab != this.selectedTab) {
                    this.selectedTab = nextTab;
                    this.tabs.clickTabWithoutEvents(nextTab.Name);
                }
            }
            setTimeout(() => {
                this.eFormService.mergeFieldPipeTrigger();
                if (this.showConditionalObjects) {
                    this.showConditionalChange();
                }
            }, 0);
        }
        // }
        this.isFirstPage();
        this.isLastPage();
    }

    isFirstPage() {
        this.isFP = true;
        if (this.eFormData && this.eFormData.Tabs && this.eFormData.Tabs.length > 0 && this.eFormData.Tabs[0].Pages && this.eFormData.Tabs[0].Pages.length > 0) {
            const visibleTabs = this.eFormData.Tabs.filter(o => o.Visible || this.showConditionalObjects || this.config.AlwaysShowAllConditionals
                && o.Pages.find(p => p.Visible || this.showConditionalObjects || this.config.AlwaysShowAllConditionals) != null);
            if (visibleTabs) {
                const firstPage = visibleTabs[0].Pages.find(o => o.Visible);
                if (this.selectedPage.Id != firstPage.Id) {
                    this.isFP = false;
                }
            }
        }
        this.eFormService.observableIsFirstPage.next(this.isFP);
        this.selectedPageNumber = this.getSelectedPageNumber();
    }


    isLastPage() {
        this.isLP = true;
        if (this.eFormData && this.eFormData.Tabs && this.eFormData.Tabs.length > 0) {
            const visibleTabs = this.eFormData.Tabs.filter(o => o.Visible || this.showConditionalObjects || this.config.AlwaysShowAllConditionals
                && o.Pages.find(p => p.Visible || this.showConditionalObjects || this.config.AlwaysShowAllConditionals) != null);
            const lastTab = visibleTabs[visibleTabs.length - 1];
            const visiblePages = lastTab.Pages.filter(o => o.Visible);
            if (visiblePages && visiblePages.length > 0) {
                const lastPage = visiblePages[visiblePages.length - 1];
                if (this.selectedPage.Id != lastPage.Id) {
                    this.isLP = false;
                }
            }
        }
        this.eFormService.observableIsLastPage.next(this.isLP);
        this.selectedPageNumber = this.getSelectedPageNumber();
    }

    showConditionalChange() {
        this.eFormService.showConditionalObjectsChanged(this.showConditionalObjects);
        this.getTabs();
    }

    getSelectedPageNumber(): number {
        let pageIndex = this.selectedTab.Pages.findIndex(o => o.Name == this.selectedPage.Name);

        if (pageIndex == -1) {
            pageIndex = this.selectedTab.Pages.findIndex(o => o.Id == this.selectedPage.Id);
        }

        return pageIndex != -1 ? pageIndex + 1 : pageIndex;
    }

    goToErrorTab(tabName: string, errors = null) {
        // this.selectedTabChanged(tabName);
        this.selectedTabChanged(tabName, errors);
        if (this.tabs) {
            this.tabs.clickTabWithoutEvents(tabName);
        }
        this.isFirstPage();
        this.isLastPage();
    }

    validatePage(onlyFileValidation: boolean = false): ErrorList[] {
        this.errors = [];
        if (!this.isPreview && !this.isReview && this.editable) {
            this.visibleTabs.forEach(tab => {
                tab.Pages.forEach(page => {
                    if (page) {
                        const pageControls = this.eFormService.getAllControlsByPage(page);
                        pageControls.forEach(control => {
                            control.HasError = false;
                            if (control.Visible) {
                                let name = control.Label ? control.Label : '';
                                const completFieldName = control.Label ? control.Label : '';
                                const controlId = control.Id ? control.Id : -1;
                                if (name.length > 30) {
                                    name = name.substr(0, 30) + '...';
                                }
                                if (!onlyFileValidation) {
                                    if (control.IsRequired) {
                                        if ((control.ControlType == this.eFormService.controlTypes.attachment && (!control.Attachment || !control.Attachment.FileDataBase64 || control.Attachment.FileDataBase64 == ''))
                                            || (control.ControlType != this.eFormService.controlTypes.attachment && !control.Value && control.Visible)) {
                                            control.HasError = true;
                                            if (control.ControlType == this.eFormService.controlTypes.checkbox) {
                                                const error: ErrorList = {
                                                    id: controlId,
                                                    fieldName: name,
                                                    completFieldName: completFieldName,
                                                    fieldRef: null,
                                                    errorMsg: ' must be checked in order to continue.',
                                                    clickCallback: () => {
                                                        this.goToErrorTab(tab.Name, error);
                                                    }
                                                };
                                                this.errors.push(error);
                                            } else {
                                                const error: ErrorList = {
                                                    id: controlId,
                                                    fieldName: name,
                                                    completFieldName: completFieldName,
                                                    fieldRef: null,
                                                    errorMsg: ' is required.',
                                                    clickCallback: () => {
                                                        this.goToErrorTab(tab.Name, error);
                                                    }
                                                };
                                                this.errors.push(error);
                                            }
                                        }
                                    }
                                }
                                if (control.ControlType == this.eFormService.controlTypes.attachment && control.Attachment && control.Attachment.FileDataBase64 && control.Visible) {
                                    const fileSize = 3 * Math.ceil((control.Attachment.FileDataBase64.length / 4) / 1000);
                                    if (fileSize > this.maxFileSizeKB) {
                                        let errorMsgText = '';
                                        if (this.maxFileSizeKB > 1000 && this.maxFileSizeKB % 1000 == 0) {
                                            errorMsgText = ' The maximum file size is ' + this.maxFileSizeKB / 1000 + ' MB.';
                                        } else {
                                            errorMsgText = ' The maximum file size is ' + this.maxFileSizeKB + ' kB.';
                                        }

                                        this.errors.push({
                                            id: controlId,
                                            fieldName: name,
                                            completFieldName: completFieldName,
                                            fieldRef: null,
                                            errorMsg: errorMsgText,
                                            clickCallback: () => {
                                                this.goToErrorTab(tab.Name);
                                            }
                                        });
                                    }
                                    if (control.ControlType == this.eFormService.controlTypes.attachment) {
                                        if (!this.allowedFileExtensions.includes(control.Attachment.FileExtension.toLocaleLowerCase()) && !this.allowedFileExtensions.includes('.' + control.Attachment.FileExtension.toLocaleLowerCase())) {
                                            this.errors.push({
                                                id: controlId,
                                                fieldName: name,
                                                completFieldName: completFieldName,
                                                fieldRef: null,
                                                errorMsg: ' Only .pdf, .bmp, .jpg and .png files can be uploaded.',
                                                clickCallback: () => {
                                                    this.goToErrorTab(tab.Name);
                                                }
                                            });
                                        }
                                    } else if (control.ControlType == this.eFormService.controlTypes.image) {
                                        if (!this.allowedImageExtensions.includes(control.Attachment.FileExtension.toLocaleLowerCase()) && !this.allowedImageExtensions.includes('.' + control.Attachment.FileExtension.toLocaleLowerCase())) {
                                            this.errors.push({
                                                id: controlId,
                                                fieldName: name,
                                                completFieldName: completFieldName,
                                                fieldRef: null,
                                                errorMsg: ' Only .bmp, .jpg and .png files can be uploaded.',
                                                clickCallback: () => {
                                                    this.goToErrorTab(tab.Name);
                                                }
                                            });
                                        }
                                    }
                                }
                            }
                        });
                    }
                });
            });
        }

        return this.errors;
    }

    async afterLocalPrint() {
        this.showPrintDiv = false;
        this.spinnerService.showSpinner = false;
        this.localPrint = false;
        this.showAllConditionalsPrint = false;
        this.columnInitializedBuffer = false;
        let fileName: string;
        if (this.fileNameOverride) {
            fileName = this.fileNameInput + '.pdf';
        } else {
            fileName = this.selectedInstance ? this.selectedInstance.Name + '.pdf' : 'eForm.pdf';
        }

        if (this.eFormService.pdfDataURIs.length == 1) {
            this.eFormService.addEFormAttachmentsToPDF(false);

            const pdfBase64 = await this.eFormService.getPdfDataUriAsBase64();

            System.saveFile(pdfBase64, 'pdf', fileName);
        }

        if (this.tabNames && this.tabNames.length > 0) {
            this.selectedTabChanged(this.tabNames[0]);
        }
    }

    async initGenerateEnglishPDFOnly(_callback) {
        if (this.selectedForm) {
            this.showPrintDiv = true;
            this.columnInitializedBuffer = false;
            this.spinnerService.showSpinner = true;

            this.eFormService.observablePageLoadCompleteStream$.pipe(take(1)).subscribe(() => {
                this.generateEnglishPDFOnly(() => {
                    this.spinnerService.showSpinner = false;
                    _callback();
                });
            });
        }
    }

    async generateEnglishPDFOnly(_callback) {
        await this.addFormToPDF();
        this.eFormService.addEFormAttachmentsToPDF();
        this.eFormService.selectedForm.EnglishPDF = await this.eFormService.getPdfDataUriAsBase64();
        _callback();
    }

    async initGenerateEFormPDFAndJSON(status: string, _callback) {
        if (this.selectedForm && (status.toLowerCase() == 'submitted' || status.toLowerCase() == 'accepted')) {
            this.showPrintDiv = true;
            this.columnInitializedBuffer = false;
            this.spinnerService.showSpinner = true;

            //  Check if any tabs or pages have been hidden since the page was initialized (ONE-12613)
            this.eFormData.Tabs.forEach(tab => {
                if (!tab.Visible) {
                    this.tabViewStatus = this.tabViewStatus.filter(status => status.TabId != tab.Id);
                }
                else {
                    tab.Pages.forEach(page => {
                        if (!page.Visible) {
                            this.tabViewStatus = this.tabViewStatus.filter(status => status.PageId != page.Id);
                        }
                    });
                }
            });

            this.eFormService.observablePageLoadCompleteStream$.pipe(take(1)).subscribe(() => {
                this.generateEFormPDFAndJSON(() => {
                    this.spinnerService.showSpinner = false;
                    _callback();
                });
            });
        } else {
            if (_callback) {
                _callback();
            }
        }
    }

    async generateEFormPDFAndJSON(_callback) {
        await this.addFormToPDF();
        this.eFormService.addEFormAttachmentsToPDF();
        this.eFormService.selectedForm.TranslatedPDF = await this.eFormService.getPdfDataUriAsBase64();

        // Transform tags in JSON for EnglishJSON
        if (!this.disableMergeFields) {
            this.eFormService.allFormControls.forEach(control => {
                if (control.ControlType == this.eFormService.controlTypes.text) {
                    control.Value = this.eFormService.transformDatabaseMergeTag(control.Value);
                } else {
                    control.Label = this.eFormService.transformDatabaseMergeTag(control.Label);
                    control.DropdownOptions.forEach(opt => {
                        opt.CodeDescription = this.eFormService.transformDatabaseMergeTag(opt.CodeDescription);
                    });
                }
            });
        }
        this.eFormService.selectedForm.EnglishJSON = JSON.stringify(this.eFormData);

        if (this.selectedInstance.StoreLocation.toLowerCase() != 'eform' && this.selectedInstance.ProcessType == 'auto') {
            if (this.userService.currentLanguage != 'en') {
                //  User is not viewing form in English, create an english version for to saving to SDC/SP
                this.convertNonEnglishFormToEnglish(() => {
                    _callback();
                });
            } else {
                // User is viewing form in English, use the PDF already creating for TranslatedPDF for saving to SDC/SP
                this.eFormService.selectedForm.EnglishPDF = this.eFormService.selectedForm.TranslatedPDF;
                _callback();
            }
        } else {
            _callback();
        }
    }

    async convertNonEnglishFormToEnglish(_callback) {
        //  Set translations pipe to revert text back to English
        this.translationService.overrideTranslationPipe = true;
        this.translationService.revertToEnglish = true;
        //  Reset flag after PDF is create for TranslatedPDF
        this.addFormToPDFStarted = false;
        //  Hide/Show form to prompt control to reinitialize text translations
        this.columnInitializedBuffer = false;
        this.showPrintDiv = false;
        await this.delay(100);
        this.showPrintDiv = true;

        this.eFormService.observablePageLoadComplete.pipe(take(1)).subscribe(() => {
            this.updateEnglishPDF(_callback);
        });
    }

    async updateEnglishPDF(_callback) {
        await this.addFormToPDF();
        this.translationService.overrideTranslationPipe = false;
        this.translationService.revertToEnglish = false;

        this.eFormService.addEFormAttachmentsToPDF();

        this.eFormService.selectedForm.EnglishPDF = await this.eFormService.getPdfDataUriAsBase64();

        _callback();
    }

    roundToTwo(num) {
        return +(Math.round(Number(num + 'e+2')) + 'e-2');
    }

    async delay(ms: number) {
        await new Promise(r => setTimeout(r, ms));
    }

    public dropped() {

    }

    async addFormToPDF() {
        //  Grab html content to be rendered
        const data = document.getElementById('formToPrint');
        if (data != null && !this.addFormToPDFStarted) {
            this.addFormToPDFStarted = true;
            if ((!this.selectedInstance || this.selectedInstance.ProcessType != 'auto') && this.config.ViewMode != enmEFormViewModes.FRMA) {
                await this.delay(500);
            }
            this.pdfExportRef.scale = .68;
            await this.pdfExportRef.export().then(async (group: Group) => {
                if (group) {
                    await exportPDF(group).then((dataURI1) => {
                        if (dataURI1) {
                            this.eFormService.pdfDataURIs.push(dataURI1);
                        }
                    });
                }
            });
            // this.eFormService.pdfDataURIs = [];
            // // this code for reload page and repushed in pdfDataURIs
            // await this.pdfExportRef.export().then(async (group: Group) => {
            //   if (group) {
            //     await exportPDF(group).then((dataURI1) => {
            //       if (dataURI1) {
            //         this.eFormService.pdfDataURIs.push(dataURI1);
            //       }
            //     });
            //   }
            // });
        } else if (!this.addFormToPDFStarted) {
            setTimeout(() => {
                this.addFormToPDF();
            }, 100);
        }
    }


    async columnInitialized(col: EFormColumn) {
        //  This will only trigger when all object in the e-form are initialized
        const colObj = this.tabViewStatus.find(o => o.Column == col);
        if (colObj) {
            colObj.Initialized = true;
        }
        if (this.tabViewStatus.find(o => o.Initialized == false) == null && !this.columnInitializedBuffer) {
            this.columnInitializedBuffer = true;
            setTimeout(() => {
                this.renderCompleted.emit(true);
            }, 0);
        }
    }

    async columnInitializedPrint(col: EFormColumn) {
        //  This will only trigger when all object in the e-form are initialized
        const colObj = this.tabViewStatus.filter(o => o.Column == col);
        if (colObj != null) {
            colObj.forEach(element => {
                if (element) {
                    element.Initialized = true;
                }
            });
        }
        if (this.tabViewStatus.find(o => o.Initialized == false) == null && !this.columnInitializedBuffer) {
            this.columnInitializedBuffer = true;
            this.eFormService.observablePageLoadComplete.next(true);
            if (this.config.ViewMode == enmEFormViewModes.FRMA) {
                await this.delay(100);
            }
            else {
                await this.delay(4500);
            }
            setTimeout(() => {
                this.eFormService.mergeFieldPipeTrigger();
            }, 0);

            if (this.languageIdOverride && this.languageIdOverride != 9 && this.languageIdOverride > -1) {
                this.languageChangePDF(() => {
                    this.addFormAndComplete();
                });
            } else {
                this.addFormAndComplete();
            }
        }
    }

    async addFormAndComplete() {
        await this.addFormToPDF();
        this.completeRender();
    }

    async completeRender() {
        setTimeout(() => {
            if (this.localPrint) {
                this.afterLocalPrint();
            } else {
                this.eFormService.renderedFormData = this.eFormData;
                this.renderCompleted.emit(true);
            }
        }, 0);
    }

    getControlLabels(control: EFormControl) {
        if (control.Label) {
            this.labels.push(control.Label);
        }
        if (control.ControlType == 'text') {
            if (control.Value) {
                this.labels.push(control.Value);
            }
        }
        if (control.ControlType == 'buttons') {
            if (control.DropdownOptions) {
                control.DropdownOptions.forEach(chip => {
                    if (chip.CodeDescription) {
                        this.labels.push(chip.CodeDescription);
                    }
                });
            }
        }
        if (control.ControlType == 'dropdown') {
            if (control.DropdownOptions) {
                control.DropdownOptions.forEach(option => {
                    if (option.CodeDescription) {
                        this.labels.push(option.CodeDescription);
                    }
                });
            }
        }
    }

    getRowLabels(rows: EFormRow[]) {
        if (rows) {
            rows.forEach(row => {
                row.Controls.forEach(control => {
                    this.getControlLabels(control);
                });
                this.getColumnLabels(row.Columns);
            });
        }
    }

    getColumnLabels(columns: EFormColumn[]) {
        if (columns) {
            columns.forEach(column => {
                column.Controls.forEach(control => {
                    this.getControlLabels(control);
                });
                this.getRowLabels(column.Rows);
            });
        }
    }

    getFormLabels() {
        this.labels = [];
        this.serviceControls = this.eFormService.getAllFormControls(this.eFormData);


        this.eFormData.Tabs.forEach(tab => {
            tab.Pages.forEach(page => {
                // this.getRowLabels(page.Rows);
                // this.getColumnLabels(page.Columns);
            });
        });

        const filer = 'filler';
    }

    getLanguages() {
        // TODO
        this.languages = [];
        let language = new Lookup();
        language.Code = 'en';
        language.CodeDescription = 'English';
        this.languages.push(language);
        language = new Lookup();
        language.Code = 'es';
        language.CodeDescription = 'Spanish';
        this.languages.push(language);
        language = new Lookup();
        language.Code = 'fr';
        language.CodeDescription = 'French';
        this.languages.push(language);
        language = new Lookup();
        language.Code = 'pt';
        language.CodeDescription = 'Portuguese';
        this.languages.push(language);

        if (this.userService.currentLanguage) {
            this.selectedLanguageCode = this.userService.currentLanguage;
        } else {
            this.selectedLanguageCode = this.languages[0].Code;
        }
    }

    languageChanged() {
        this.languageChange = true;

        let language_ID: number;

        //  TODO change to dto lookup
        //  language must be 'en' for English, 'fr' for French, or 'es' for Spanish, or 'pt' for portuguese
        switch (this.selectedLanguageCode) {
            case 'fr':
                language_ID = 7;
                break;
            case 'es':
                language_ID = 1;
                break;
            case 'pt':
                language_ID = 107;
                break;
            default:
                // en
                language_ID = 9;
        }

        this.translationService.overrideTranslationPipe = true;
        this.translationService.getTranslationsForLanguage(language_ID).pipe(take(1)).subscribe(result => {
            this.translationService.overrideTranslations = result;
            this.showContent = false;
            setTimeout(() => {
                this.showContent = true;
            }, 0);
        });

        // changed for ONE-5073, the e-Form preview only uses tyl-translate now
        // this.userService.setUserLanguage(this.selectedLanguageCode).subscribe(result => {
        //   this.showContent = false;
        //   setTimeout(() => {
        //     this.showContent = true;
        //   }, 0);
        // });
    }

    async languageChangePDF(_callback) {
        this.languageChange = true;
        this.translationService.overrideTranslationPipe = true;
        this.translationService.getTranslationsForLanguage(this.languageIdOverride).pipe(take(1)).subscribe(result => {
            this.translationService.overrideTranslations = result;
            this.showContent = false;
            setTimeout(() => {
                this.showContent = true;
                _callback();
            }, 500);
        });
    }

    checkVisiblePageCount(): boolean {
        return this.selectedTab ? (this.selectedTab.Pages.filter(o => o.Visible).length > 1) : false;
    }

    getAllCustomFields(designPageIndex: number): EFormControl[] {
        return this.eFormService.allCustomFieldControls.filter(control => control.CustomField
            && (designPageIndex == -1 || control.DesignPageIndex == designPageIndex));
    }

    getCustomFieldByRefName(refName: string, designPageIndex: number): EFormControl {
        return this.eFormService.allCustomFieldControls.find(control => control.CustomFieldRefName
            && control.CustomFieldRefName == refName
            && (designPageIndex == -1 || control.DesignPageIndex == designPageIndex));
    }

    setCustomFieldByRefName(value: any, refName: string, designPageIndex: number) {
        const c: EFormControl = this.eFormService.allCustomFieldControls.find(control => control.CustomFieldRefName
            && control.CustomFieldRefName == refName
            && (designPageIndex == -1 || control.DesignPageIndex == designPageIndex));
        if (c) {
            c.Value = value;
        }
    }

    setLinkedDBFieldValues() {
        // we have to do both checks because some controls will have been linked to DB fields before Customization Framework was enabled.
        let fieldIds: number[] = [];
        const cfEnabled = this.loginService.LoginSettings.EnableCustomizationFramework && this.loginService.LoginSettings.C360CustomFieldsImported;
        fieldIds = this.eFormService.allFormControls.filter(c => c.LinkedDBField != -1 && (!cfEnabled || !c.LinkedCSTFieldName)).map(o => o.LinkedDBField);
        if (fieldIds.length > 0) {
            this.eFormService.getLinkedDBFieldValues(fieldIds, this.selectedForm ? this.selectedForm.Student_ID : 0).pipe(take(1)).subscribe(result => {
                result.forEach(f => {
                    const index: number = this.eFormService.allFormControls.findIndex(c => c.LinkedDBField == f.ID);

                    if (index > -1 && f.Value) {
                        this.eFormService.allFormControls[index].Value = f.Value;
                        this.eFormService.allFormControls[index].HintLabel = f.Value;
                    }
                });
            });
        }
        if (cfEnabled && this.eFormService.allFormControls.filter(c => c.LinkedCSTFieldName).length > 0) {
            this.customizationFrameworkService.getLinkedCustomFields(this.eFormData, this.selectedForm).pipe(take(1)).subscribe(customFields => {
                this.selectedForm.CustomFields = customFields;
                this.customizationFrameworkService.massGetCustomDataFieldValue(this.yearService.defaultYear.SiteYearId, customFields).pipe(take(1)).subscribe(fields => {
                    fields.forEach(f => {
                        const controlToUpdate = this.eFormService.allFormControls.find(c => c.LinkedCSTFieldName == f.FieldName);
                        if (controlToUpdate) {
                            controlToUpdate.Value = f.Value;
                        }
                    });
                });
            });
        }
    }
}
